import { RequestMethod, ServerContext } from './types/api';

export const callMT = async (
  url: string,
  method: RequestMethod,
  body: any,
  headers
) => {
  const response = await fetch(url, {
    method,
    body: JSON.stringify(body),
    headers,
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  return response.json();
};

export const getHeadersRequestByServerContext = (serverContext: ServerContext) => ({
  'Content-Type': 'application/json',
  lcid: serverContext.CurrentUser.Locale,
  'x-ms-clientapplication': 'bingadsweb',
  'x-ms-applicationname': 'bingadsweb',
  'x-ms-pagetrackingid': serverContext.PageTrackingId,
  Authorization: `CCMTSmallToken ${serverContext.Token}`,
  CustomerAccountId: serverContext.CurrentAccount.Id,
  CustomerId: serverContext.CurrentAccount.AdvertiserCustomerID,
});
